import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class InterviewsSkills {
	/**
	 * @path /pages/:pgid/skills
	 * @returns { skills: PGSchema.interview_skills[] }
	 */
	async getInterviewSkills(pgid: string, token: string) {
		return xget<{ skills: PGSchema.interview_skills[] }>(`/pages/${pgid}/skills`, {}, { headers: { "app-token": token! } });
	}
	/**
	 * @path /pages/:pgid/skills
	 * @param skill: Partial<PGSchema.interview_skills>
	 * @returns { skill: PGSchema.interview_skills }
	 */
	async createInterviewSkills(pgid: string, skill: Partial<PGSchema.interview_skills>, token: string) {
		return xhttp<{ skill: PGSchema.interview_skills }>(`/pages/${pgid}/skills`, "POST", [skill], { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/skills
	 * @param skill: Partial<PGSchema.interview_skills>
	 * @returns { skill: PGSchema.interview_skills }
	 */
	async createInterviewSkillsMultiple(pgid: string, skill: Partial<PGSchema.interview_skills>[], token: string) {
		return xhttp<{ skills: PGSchema.interview_skills[] }>(`/pages/${pgid}/skills`, "POST", skill, { headers: { "app-token": token! } });
	}
	/**
	 * @path /pages/:pgid/skills/:id
	 * @param skill: Partial<PGSchema.interview_skills>
	 * @param token: string
	 * @param id: string
	 * @returns { skill: PGSchema.interview_skills }
	 */
	async updateInterviewSkills(pgid: string, id: string, skill: Partial<PGSchema.interview_skills>, token: string) {
		return xhttp<{ skill: PGSchema.interview_skills }>(`/pages/${pgid}/skills/${id}`, "PUT", skill, { headers: { "app-token": token! } });
	}
	/**
	 * @path /pages/:pgid/skills/:id
	 * @param id: string
	 * @param token: string
	 * @returns { skill: PGSchema.interview_skills }
	 */
	async deleteInterviewSkills(pgid: string, id: string, token: string) {
		return xhttp<{ skill: PGSchema.interview_skills }>(`/pages/${pgid}/skills/${id}`, "DELETE", {}, { headers: { "app-token": token! } });
	}
}
